export const locales: Locale[] = [
	{ code: 'en', language: 'en', file: 'en.json', name: 'English' },
	{ code: 'us', language: 'en-US', file: 'en_US.json', name: 'English US' },
	{ code: 'fi', language: 'fi-FI', file: 'fi.json', name: 'Suomi' },
	{ code: 'sv', language: 'sv-SE', file: 'sv.json', name: 'Svenska' },
	{ code: 'de', language: 'de-DE', file: 'de_DE.json', name: 'Deutsch' }
]
